import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

/** Pending placeholder for the Payment methods screen — shares the View frame with the real content. */
export function PaymentMethodsPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')}>
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={260} height={32} />
        </View.Header>
        <View.Body>
          {[0, 1].map((key) => (
            <Section.Root key={key}>
              <Section.Header
                className="
                  grid-cols-[minmax(0,1fr)]
                  md:grid-cols-[minmax(0,1fr)_auto]
                "
              >
                <Section.Title.Skeleton width="70%" />
                <Section.Subtitle.Skeleton width="60%" height={18} />
                <Section.Actions
                  className="
                    col-start-1 row-span-1 row-start-3 mt-40
                    md:col-start-2 md:row-span-2 md:row-start-1 md:mt-0
                  "
                >
                  <Skeleton
                    variant="block"
                    className="
                      h-[48px] w-full
                      md:h-[32px] md:w-[117px]
                    "
                  />
                </Section.Actions>
              </Section.Header>
              <Section.Body>
                <Skeleton variant="block" height={74} />
              </Section.Body>
            </Section.Root>
          ))}
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
